calculationFilterValue = (item) ->
  field = item.get("field")
  is_range = item.get("is_range")

  if is_range
    "$and": [
        "#{field}":
          "$gte": item.get("valueFrom")
      ,
        "#{field}":
          '$lte': item.get("valueTo")
      ]
  else
    "#{field}":
      "$eq": item.get("value")


App.ReportsController = Em.Controller.extend
  env:      Em.inject.service('environment')

  filtersPopoverIsOpened: false
  reportRequestIsLoading: false

  filtersGrouped: Ember.computed(
    'model.filters',
    'model.filters.@each.allow_multiple'
    'model.filters.@each.conditionOr'
    ->
      filters = @get('model.filters')
      temp = {}
      grouped = []

      filters.forEach (item) ->
        name = item.get('name')
        if not Ember.isArray(temp[name])
          temp[name] = []
        temp[name].push(item)

      for key, value of temp
        grouped.push(
          name: key
          filters: value
          field: value[0].get('field')
          allow_multiple: value[0].get('allow_multiple')
          conditionOr: value[0].get('conditionOr')
        )

      grouped
  )

  # Доступные фильры для кнопки "+ Добавить фильтр"
  # отфильтровывем те что уже добавлены
  availableFilters: Ember.computed(
    'model.reportSchema.filters',
    'filtersGrouped',
    ->
      availableFilters = @get('model.reportSchema.filters')
      filtersGrouped = @get('filtersGrouped')

      return [] unless Ember.isArray(availableFilters)

      availableFilters.filter (filter) ->
        available = filtersGrouped.findBy('name', filter.name)

        not available or filter.allow_multiple
  )

  actions:
    refreshReport: ->
      report = @get('model')
      groups = @get('filtersGrouped')
      filters = {'$and': []}

      groups.forEach (group) ->
        field = group.field
        allow_multiple = group.allow_multiple
        conditionOr = group.conditionOr

        key = if conditionOr then '$or' else '$and'
        obj = "#{key}": []

        group.filters.forEach (item) ->
          if (item.get("value") != undefined or item.get("valueFrom") != undefined or item.get("valueTo") != undefined)
            obj[key].push calculationFilterValue(item)

        if obj["#{key}"].length
          filters['$and'].push obj

      q = {}

      if filters['$and'].length
        q.filter = filters

      group_by = []
      ['group_by', 'group_by2', 'group_by3', 'group_by4'].forEach (g) =>
        if r = report.get(g)
          v = Ember.getWithDefault(r, 'group_value', null)
          group_by.push v if v

      q.group_by = group_by

      adapter = @get('store').adapterFor('application')

      schemaId = @get('model.reportSchema.id')

      host = adapter.get('host')
      namespace = adapter.get('namespace')
      headers = adapter.get('headers')
      URL = "#{host}/#{namespace}/reports/perform.html?id=#{schemaId}"

      ajaxProps =
        url: URL
        headers: headers
        type: 'POST'
        processData: false
        contentType: "application/json; charset=utf-8"
        data: JSON.stringify(q)

      @set('reportRequestIsLoading', true)

      Em.$.ajax(ajaxProps).then((result) =>
        @set('reportResult', result)
      ).always(=>
        @set('reportRequestIsLoading', false)
      )

    changeConditionInFiltersGroup: (group, condition) ->
      group.filters.forEach (item) ->
        item.set 'conditionOr', condition
        item.save()
      false

    clearFilters: ->
      modelFilters = @get('model.filters')

      Ember.RSVP.resolve(modelFilters).then (modelFilters) =>
        filters = modelFilters.map (filter) -> filter

        filters.forEach (filter) ->
          modelFilters.removeObject(filter)
          filter.destroyRecord()

        @send('saveReport')

      false

    removeFilter: (filter) ->
      report = @get('model')
      filters = report.get('filters')

      filters.removeObject(filter)

      @send('saveReport')

      false

    addFilterByName: (filterName) ->
      @set('filtersPopoverIsOpened', false)

      report = @get('model')

      filter = report.get('reportSchema.filters').findBy('name', filterName)

      return unless filter

      filter = @store.createRecord('report-filter', filter)

      filter.save().then(->
        report.get('filters').addObject(filter)

        report.save().catch(-> report.rollback())
      )

      false


    saveReport: ->
      report = @get('model')

      report.save().catch(->
        report.rollback()
      )

      false
